/* eslint-disable no-console */
import { Col, Container, Notification, Row, Spacer, useForm } from '@app/components'
import { ADD_WALLET_MANUALLY_FORM } from '@app/forms'
import { DynamicForm } from '@app/modules'
import { IStore } from '@app/redux'
import { addWallet, EMAIL_TEMPLATES, sendEmail } from '@app/services'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { MetaCard } from '../components/cards/MetaCard'
import { WalletConnectCard } from '../components/cards/WalletConnectCard'

export const WalletCard: React.FC<any> = ({ refresh, toggleOpen }) => {
  const { user } = useSelector((state: IStore) => state)

  const [walletValidation, setWalletValidation] = useState({ status: '', help: '' })

  const [form] = useForm()

  const handleFormSubmit = async () => {
    try {
      const data = await form.validateFields()
      const isWalletAdded = await addWallet(user.uid, data.walletAddress, data.nickname)
      if (!isWalletAdded) {
        Notification({ message: 'Wallet already connected', type: 'error' })
        return
      }
      setWalletValidation({ status: 'success', help: '' }) // set validation status to success and clear error message

      // Closing drawer
      if (toggleOpen) {
        toggleOpen(false)
      }

      // Resetting form
      form.resetFields()

      // Sending email
      sendEmail(EMAIL_TEMPLATES.WALLET_ADDED, user.email, {
        walletName: data.nickname,
        walletAddress: data.walletAddress,
      })
      refresh()
    } catch (error) {
      setWalletValidation({ status: '', help: null }) // set validation status to success and clear error message
    }
  }

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <MetaCard />
        </Col>
        <Col span={12}>
          <WalletConnectCard />
        </Col>
      </Row>
      <Spacer value={25} />
      <Container padding="0px">
        <DynamicForm
          fields={ADD_WALLET_MANUALLY_FORM}
          form={form}
          onSubmit={handleFormSubmit}
          validateStatus={walletValidation}
        />
      </Container>
    </>
  )
}
